
export function Button({label, isDisabled, onClick, primary, tooltip}) {
    const common_styles = 'w-full px-6 py-3 rounded-lg font-medium transition-colors'
    const secondary_styles = 'border border-gray-300 text-gray-700 hover:bg-gray-50'
    const enabled_styles = 'bg-green-600 text-white hover:bg-green-700'
    const disabled_styles = 'bg-gray-200 text-gray-800'
    // a disabled button emits no pointer events, so the tooltip has to live on a wrapper
    const showTooltip = Boolean(isDisabled && tooltip)
    const styles = `${common_styles} ${isDisabled ? disabled_styles : (primary ? enabled_styles: secondary_styles)} ${showTooltip ? 'pointer-events-none' : ''}`

    const button = (
        <button
            type="submit"
            className={styles}
            onClick={onClick}
            disabled={isDisabled}
          >
            {label}
        </button>
    )

    if (!showTooltip) return button

    return (
        <div className="relative group w-full">
            {button}
            {/* right-anchored and viewport-capped: the wizard card clips overflow on the x axis */}
            <div className="pointer-events-none absolute bottom-full right-0 mb-2 z-20 hidden group-hover:block w-max max-w-[min(20rem,calc(100vw-4rem))] rounded-md bg-gray-900 px-3 py-2 text-xs text-white text-center shadow-lg">
                {tooltip}
                <div className="absolute top-full right-6 border-4 border-transparent border-t-gray-900" />
            </div>
        </div>
    )
}